import { render, staticRenderFns } from "./question-select.vue?vue&type=template&id=5dc99a52&scoped=true&"
import script from "./question-select.vue?vue&type=script&lang=ts&"
export * from "./question-select.vue?vue&type=script&lang=ts&"
import style0 from "./question-select.vue?vue&type=style&index=0&id=5dc99a52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc99a52",
  null
  
)

export default component.exports